module.exports = __webpack_public_path__ + "static/media/linkedin_icon.3cbbedde.svg";